const getFill = (variant) => {
  let color = "--dsf-color-primary-300";
  switch (variant) {
    case "dark":
      color = "--dsf-color-neutral-500";
      break;
    case "light":
      color = "--dsf-color-neutral-0";
      break;
  }
  return `rgb(var(${color}))`;
};
export {
  getFill
};
